<script setup lang="ts">
import type { Props } from '@/shared/ui/Skeleton/model/types/skeleton';

withDefaults(defineProps<Props>(), {
  width: '100%',
  height: '100%',
  maxWidth: '100%',
});
</script>

<template>
  <div class="skeleton" :style="{ width, height, maxWidth }"></div>
</template>

<style lang="less" scoped>
.skeleton {
  display: block;
  position: relative;
  overflow: hidden;
  background: @color-black-haze;
  border-radius: @main-size;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    max-width: 1000px;
    height: 100%;
    background: linear-gradient(to right, transparent 0%, #e1e1e1 15%, transparent 30%);
    animation-duration: 1.5s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: blink-animation;
    animation-timing-function: linear;
  }
}
</style>
